/**
 * Errors we deliberately don't report — to Sentry OR PostHog.
 *
 * These are third-party library bugs, browser-extension noise, OS WebView
 * internals and transient connectivity, none of which we can fix and all of
 * which bury the errors we can.
 *
 * ONE list, imported by both reporters. Previously Sentry and PostHog kept
 * separate lists that shared only 3 of 13 entries, so the same junk error was
 * hidden in one tool and cluttered the other.
 *
 * Matching is substring-based in both:
 *   - Sentry: `ignoreErrors` does substring matching on plain strings
 *   - PostHog: `before_send` uses indexOf over $exception_list values
 */
export const IGNORED_ERROR_PATTERNS = [
  // --- third-party libraries we can't fix ---
  '_leaflet_pos',            // vue2-leaflet: moveEndHandler after component destroy
  "reading 'jumpTo'",        // maplibre-gl-leaflet: move handler outliving a failed GL init

  // --- no useful information ---
  'Script error.',           // cross-origin script, browser withholds the details

  // --- browser extensions, not our code ---
  "tabId' from null",
  'runtime.sendMessage',
  'Object Not Found Matching Id',
  'nrWrapper',               // New Relic wrapper, removed but old bundles linger

  // --- OS / WebView internals ---
  'Java object is gone',     // Android WebView

  // --- transient connectivity, not application bugs ---
  'Network Error',           // axios: request never got a response
  'Network request failed',
  'Load failed',             // Safari's equivalent

  // --- expected states, already handled in code ---
  'Request failed with status code 401',   // unauthenticated user
  'Non-Error promise rejection captured with value: undefined',
  'Non-Error promise rejection captured with value: [object CustomEvent]',
]

/** True when `text` contains any ignored pattern. */
export function isIgnoredError (text) {
  if (typeof text !== 'string' || text === '') return false
  for (var i = 0; i < IGNORED_ERROR_PATTERNS.length; i++) {
    if (text.indexOf(IGNORED_ERROR_PATTERNS[i]) !== -1) return true
  }
  return false
}
